export default {
    "pricing.hero.title": "Choisissez la formule qui vous convient",
    "pricing.hero.description": "Accédez à la meilleure plateforme de préparation pour l'examen de citoyenneté canadienne. Simple, efficace et garanti.",
    "pricing.promo.banner": "Offre spéciale du mois de l'amour ! 💝 Profitez de 30% de réduction sur tous nos plans.",
    "pricing.promo.code_label": "Utilisez le code : LOVE30",

    "pricing.plans.free.name": "Gratuit",
    "pricing.plans.free.subtitle": "Essayer CitoyenPro",
    "pricing.plans.free.description": "Commencez votre préparation et découvrez nos outils d'apprentissage.",
    "pricing.plans.free.feature1": "Mode sombre inclus",
    "pricing.plans.free.feature2": "Limité à 10 questions/quiz",
    "pricing.plans.free.feature3": "Statistiques basiques",
    "pricing.plans.free.feature4": "Accès limité aux thèmes",
    "pricing.plans.free.feature5": "Publicité minimale",
    "pricing.plans.free.feature6": "📖 Livre Découvrir le Canada (EPUB)",
    "pricing.plans.free.accroche": "Idéal pour tester l'application avant de s'engager.",
    "pricing.plans.free.cta": "Commencer maintenant",

    "pricing.plans.standard.name": "Standard",
    "pricing.plans.standard.subtitle": "Le plus populaire",
    "pricing.plans.standard.description": "Tout ce qu'il faut pour maîtriser le guide et réussir l'examen.",
    "pricing.plans.standard.feature1": "Tous les thèmes débloqués",
    "pricing.plans.standard.feature2": "Quiz illimités",
    "pricing.plans.standard.feature3": "Flashcards illimitées",
    "pricing.plans.standard.feature4": "Statistiques avancées",
    "pricing.plans.standard.feature5": "Zéro publicité",
    "pricing.plans.standard.feature6": "Accès multi-plateforme",
    "pricing.plans.standard.feature7": "📖 Livre Découvrir le Canada (EPUB)",
    "pricing.plans.standard.accroche": "La formule idéale pour une préparation complète et efficace.",
    "pricing.plans.standard.cta": "Choisir Standard",

    "pricing.plans.premium.name": "Premium",
    "pricing.plans.premium.subtitle": "La totale",
    "pricing.plans.premium.description": "L'expérience d'apprentissage ultime avec tous nos outils exclusifs.",
    "pricing.plans.premium.feature1": "Tout du plan Standard",
    "pricing.plans.premium.feature2": "Examens blancs illimités",
    "pricing.plans.premium.feature3": "Résumés Audio complets",
    "pricing.plans.premium.feature4": "Support prioritaire 24/7",
    "pricing.plans.premium.feature5": "Nouveautés en avant-première",
    "pricing.plans.premium.feature6": "Garantie de satisfaction",
    "pricing.plans.premium.feature7": "📖 Livre Découvrir le Canada (EPUB)",
    "pricing.plans.premium.accroche": "Pour ceux qui ne veulent rien laisser au hasard et maximiser leurs chances.",
    "pricing.plans.premium.cta": "Passer au Premium",

    "pricing.status.per_month": "/ mois",
    "pricing.status.tax_included": "Taxes incluses",
    "pricing.status.loading": "Chargement...",
    "pricing.status.current": "Votre offre actuelle",
    "pricing.status.manage": "Gérer mon offre",
    "pricing.status.upgrade_premium": "Passer au Premium",
    "pricing.status.downgrade_standard": "Passer au Standard",

    "pricing.faq.title": "Questions Fréquentes",
    "pricing.faq.q1": "Puis-je annuler mon abonnement à tout moment ?",
    "pricing.faq.a1": "Oui, absolument. CitoyenPro est sans engagement. Vous pouvez annuler votre abonnement en un clic depuis vos paramètres. Vous garderez l'accès premium jusqu'à la fin de votre période de facturation.",
    "pricing.faq.q2": "Quelle est la différence entre Standard et Premium ?",
    "pricing.faq.a2": "Le plan Standard débloque tout le contenu (thèmes, quiz, flashcards). Le plan Premium ajoute les examens blancs (chronométrés comme l'officiel) et les résumés audio pour apprendre sans écran. Le livre Découvrir le Canada au format EPUB est inclus gratuitement dans tous les plans.",
    "pricing.faq.q3": "Les questions sont-elles à jour ?",
    "pricing.faq.a3": "Oui, notre équipe met à jour la base de données dès qu'un changement est effectué dans le guide officiel 'Découvrir le Canada'.",
    "pricing.faq.q4": "Puis-je utiliser CitoyenPro sur plusieurs appareils ?",
    "pricing.faq.a4": "Bien sûr ! Votre compte est synchronisé sur votre ordinateur, tablette et téléphone. Vous pouvez reprendre votre étude là où vous l'avez laissée.",
    "pricing.faq.q5": "Quels sont les modes de paiement acceptés ?",
    "pricing.faq.a5": "Nous utilisons Stripe pour sécuriser les transactions. Nous acceptons toutes les cartes de crédit majeures (Visa, Mastercard, Amex) ainsi qu'Apple Pay et Google Pay."
};
